import { CollectionMethodConstants as Constants } from '../types'
import { collectionApi as api } from '../../api'

export const collectionMethodAction = {
    get,
}

function get() {
    return dispatch => {
        dispatch({ type: Constants.LOADING })
        return new Promise((resolve, reject) => {
            api._getMethods()
                .then(
                    payload => {
                        dispatch({ type: Constants.GET, payload })
                        resolve(payload)
                    },
                    error => {
                        dispatch({ type: Constants.FAIL, error })
                        reject(error)
                    }
                )
        })
    }
}
